import './css/dashboardtable.css';
import './css/editform.css';
import React, { useState, useEffect } from "react";
import axios from '../../config/index';
import { Link, useNavigate } from 'react-router-dom';
import { useLocation, useParams } from 'react-router-dom';




function EditBenefits() {



    useEffect(() => {
        axios.get('session')
            .then((res) => {
                if (res.data.valid) {
                    if (res.data.type !== "admin") {
                        navigate('/admin-login');
                    }
                } else {
                    // Handle the case when session is not valid
                }
            })
            .catch((err) => console.log(err));
    }, []);




    const [formChanged, setFormChanged] = useState(false); // Track if the form has changed


    const handleInputChange = () => {
        setFormChanged(true); // Set the formChanged flag to true when any input changes
    };




    const navigate = useNavigate();
    const [BenefitsData, setBenefitsData] = useState({});
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const id = queryParams.get('id');


    const [formInputs, setFormInputs] = useState({
        header_1: "",
        para_1: "",
        header_2: "",
        para_2: "",
        header_3: "",
        para_3: "",

    });
    
    // Use formInputs to set the initial value of inputs
    useEffect(() => {
        if (BenefitsData.id) {
        setFormInputs({
            header_1: BenefitsData.header_1,
            para_1: BenefitsData.para_1,
            header_2: BenefitsData.header_2,
            para_2: BenefitsData.para_2,
            header_3: BenefitsData.header_3,
            para_3: BenefitsData.para_3,
        });
        }
    }, [BenefitsData]);

        const handleChange = (e) => {
            handleInputChange();
            const { name, value, type } = e.target;
            const inputValue = type === "file" ? e.target.files[0] : value;
        
            setFormInputs((prevFormInputs) => ({
            ...prevFormInputs,
            [name]: inputValue,
            }));
        };


        
        const handleSubmit = async (e) => {
            e.preventDefault();
        
            let Loading = document.querySelector(".loading-screen");
            Loading.classList.add("active");
        
            const { header_1, para_1, header_2, para_2, header_3, para_3} = formInputs;
        
            if (!header_1 || !para_1 || !header_2 || !para_2 ||!header_3 || !para_3 ) {
            return alert("All fields are required");
            }
        
            try {
            const form = new FormData();
            form.append("id", id);
            form.append("header_1", header_1);
            form.append("para_1", para_1);
            form.append("header_2", header_2);
            form.append("para_2", para_2);
            form.append("header_3", header_3);
            form.append("para_3", para_3);
        
            const response = await axios.post("/update-benefits", form);
        
            if (response.status === 200) {
                // Update LandingSlide state after a successful update
                setBenefitsData((prevBenefitsData) => ({
                ...prevBenefitsData,
                header_1, para_1, header_2, para_2, header_3, para_3
                }));
        
                Loading.classList.remove("active");
                let alertS = document.querySelector(".alert-success");
                alertS.classList.add("active");
        
                setTimeout(() => {
                alertS.classList.remove("active");
                }, 3000);
            } else {
                Loading.classList.remove("active");
                let alertD = document.querySelector(".alert-danger");
                alertD.classList.add("active");
                setTimeout(() => {
                alertD.classList.remove("active");
                }, 3000);
            }
            } catch (error) {
            console.error(error);
            alert("Server error");
            }
        };




    axios.defaults.withCredentials = true;
    
    const getAllBenefits = (itemId) => {
        let table = "benefits";
        axios.post('get-item', { itemId, table })
            .then((res) => {
                if (res.data.message) {
                } else {
                    setBenefitsData(res.data);
                }
            })
            .catch((err) => console.log(err));
    };




    const getIfLogin = () => {
        axios.get('session')
            .then((res) => {
                if (!res.data.valid || id <= 0 || id == null || id == "") {
                    navigate('/admin-login');
                } else {
                    getAllBenefits(id);
                }
            })
            .catch((err) => console.log(err));
    };
    



    useEffect(() => {
        getIfLogin();
        getAllBenefits(id);
    }, []);
    
    return (
        <>

<div className='loading-screen'>
                            <div class="loader">
                                <div class="outer"></div>
                                <div class="middle"></div>
                                <div class="inner"></div>
                            </div>

                        </div>
            <section className='dashboard'>
                <div className='edit-form'>

                
                <div className='alert-success'>
                        <h1> Data Added successfully  <i class="las la-check-circle"></i></h1>
                    </div>

                    <div className='alert-danger'>
                        <h1> Failed To Add Data <i class="las la-exclamation-triangle"></i></h1>

                    </div>


                    <form onSubmit={handleSubmit}>
                
                        <div className='input'>
                            <label> Header 1 </label>
                            <input  value={formInputs.header_1} onChange={handleChange} type='text' required="required"  maxLength="200" name='header_1'/>
                        </div>



                        <div className='input'>
                            <label> Text 1 </label>
                            <textarea value={formInputs.para_1} onChange={handleChange} type='text' required="required"  maxLength="700" name='para_1'>
                                
                            </textarea>
                        </div>


                        <div className='input'>
                            <label> Header 2 </label>
                            <input  value={formInputs.header_2} onChange={handleChange} type='text' required="required"  maxLength="200" name='header_2'/>
                        </div>



                        <div className='input'>
                            <label> Text 2 </label>
                            <textarea value={formInputs.para_2} onChange={handleChange} type='text' required="required"  maxLength="700" name='para_2'>
                                
                            </textarea>
                        </div>




                        <div className='input'>
                            <label> Header 3 </label>
                            <input  value={formInputs.header_3} onChange={handleChange} type='text' required="required"  maxLength="200" name='header_3'/>
                        </div>



                        <div className='input'>
                            <label> Text 3 </label>
                            <textarea value={formInputs.para_3} onChange={handleChange} type='text' required="required"  maxLength="700" name='para_3'>
                                
                            </textarea>
                        </div>

                                <button disabled={!formChanged} type='submit'> Update </button>
                            </form>
                        </div>
                    </section>
                </>
            );
            }
            


            export default EditBenefits;
